var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgRight = function SvgRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 30,
    viewBox: "0 0 15 30",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 29.497a.498.498 0 01.147-.357l13.685-14.138L.147.864A.504.504 0 01.04.314.504.504 0 01.494 0 .473.473 0 01.84.15l14.022 14.495a.53.53 0 010 .714L.837 29.854a.488.488 0 01-.536.107.507.507 0 01-.301-.464z",
    fill: "#333"
  })));
};

export default SvgRight;